import { transient, autoinject } from "aurelia-dependency-injection";
import { CacheClientService, CacheLocation } from "@rightship-tech/common-ui/services/basic/client-caching.service";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { NotificationClientService, NotificationType } from "../notification-client.service";
import { NavigationClientService } from "../navigation-client.service";

@autoinject
@transient()
export class LoginDialog {
    page: string;
    key: string = "REDIRECT";
    model: ILoginDialog;

    constructor(private cacheClient: CacheClientService, private requestClient: RequestClientService, private notificationClientService: NotificationClientService,
        private navigationClient: NavigationClientService) {
    }

    activate(model: ILoginDialog) {
        this.model = model;
        this.page = location.origin + "/login";
    }

    func: any;

    attached() {
        this.func = this.handleMessage;
        window.addEventListener('message', this.func, false);
    }

    private handleMessage = (event: MessageEvent): void => {
        if (event.data == this.key) {
            this.cacheClient.put(this.key, this.model, CacheLocation.LocalStorage).then(() => {
                const parentUrl: string = document.referrer;
                (<any>window.parent).location = <any>parentUrl;
            });
        }
    };

    processMessage() {
        return new Promise<void>((resolve) => {
            this.cacheClient.get<ILoginDialog>(this.key, CacheLocation.LocalStorage, false).then(x => {
                if (x) {
                    this.cacheClient.remove(this.key, CacheLocation.LocalStorage);

                    const method = x.method.toLowerCase();
                    if (method == "get") {
                        this.requestClient.get(x.url, x.params).then(() => {
                            this.cacheClient.get<any>(this.navigationClient.previousRouteKey, CacheLocation.LocalStorage, false).then(route => {
                                resolve();
                                setTimeout(() => {
                                    if (route)
                                        this.navigationClient.navigateAndCache(route.routeName, route.params);
                                    this.notificationClientService.show("Action completed successfully", "", NotificationType.Success);
                                }, 100);
                            });
                        }, e => {
                            this.cacheClient.get<any>(this.navigationClient.previousRouteKey, CacheLocation.LocalStorage, false).then(route => {
                                resolve();
                                setTimeout(() => {
                                    if (route)
                                        this.navigationClient.navigateAndCache(route.routeName, route.params);
                                    this.notificationClientService.show("Action failed to complete", e, NotificationType.Error);
                                }, 100);
                            });
                        });
                    } else if (method == "post") {
                        this.requestClient.post(x.url, x.params, x.data).then(() => {
                            this.cacheClient.get<any>(this.navigationClient.previousRouteKey, CacheLocation.LocalStorage, false).then(route => {
                                resolve();
                                setTimeout(() => {
                                    if (route)
                                        this.navigationClient.navigateAndCache(route.routeName, route.params);
                                    this.notificationClientService.show("Action completed successfully", "", NotificationType.Success);
                                }, 100);
                            });
                        }, e => {
                            this.cacheClient.get<any>(this.navigationClient.previousRouteKey, CacheLocation.LocalStorage, false).then(route => {
                                resolve();
                                setTimeout(() => {
                                    if (route)
                                        this.navigationClient.navigateAndCache(route.routeName, route.params);
                                    this.notificationClientService.show("Action failed to complete", e, NotificationType.Error);
                                }, 100);
                            });
                        });
                    }
                } else {
                    resolve();
                }
            });
        });
    }

    detached() {
        window.removeEventListener('message', this.func);
    }
}

export interface ILoginDialog {
    method: string;
    url: string;
    params?: any;
    data?: any;
}
